import { useEffect, useState } from 'react'

/**
 * Estrategia responsiva de Safyro Finanzas (app/breakpoints.ts), un solo
 * código para los tres shells:
 *   mobile  < 768px   -> BottomNavBar + FAB, una columna
 *   tablet  768–1279  -> NavRail lateral de íconos
 *   desktop >= 1280   -> Sidebar con etiquetas
 */
export const BREAKPOINTS = {
  tablet: 768,
  desktop: 1280,
}

function resolve(width) {
  if (width >= BREAKPOINTS.desktop) return 'desktop'
  if (width >= BREAKPOINTS.tablet) return 'tablet'
  return 'mobile'
}

export function useBreakpoint() {
  const [bp, setBp] = useState(() =>
    typeof window === 'undefined' ? 'mobile' : resolve(window.innerWidth)
  )

  useEffect(() => {
    const onResize = () => setBp(resolve(window.innerWidth))
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return bp
}
